var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCustomericon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2772",
    "data-name": "Group 2772",
    transform: "translate(-173 -516)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1284",
    "data-name": "Rectangle 1284",
    width: 25,
    height: 25,
    transform: "translate(173 516)",
    fill: "rgba(255,255,255,0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_124",
    "data-name": "Group 124",
    transform: "translate(-197.796 221.429)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1885",
    "data-name": "Path 1885",
    d: "M-2.929-5.858A12.071,12.071,0,0,0,9.142-17.929,12.071,12.071,0,0,0-2.929-30,12.071,12.071,0,0,0-15-17.929,12.071,12.071,0,0,0-2.929-5.858",
    transform: "translate(386.226 325)",
    fill: "#9a9b9f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_259",
    "data-name": "Group 259",
    transform: "translate(245.256 176.84)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon6",
    transform: "translate(131.969 125.16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2112",
    "data-name": "Group 2112",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1689",
    "data-name": "Path 1689",
    d: "M-5.438-20.914H5.938m-.123-.925L.25-24.8l-5.565,2.962ZM-5.136-15.15H5.636M-5.756-14.1H6.257M-6.449-13.05h13.4M-4.346-20.885v5.735m1.385-5.735v5.735m2.415-5.735v5.735M.838-20.885v5.735m2.415-5.735v5.735m1.385-5.735v5.735",
    transform: "translate(5.589 23.046)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7
  }))))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomericon);
export default __webpack_public_path__ + "static/media/customericon.b5405a559f7546bad8d6c7277093457c.svg";
export { ForwardRef as ReactComponent };